module.exports = __webpack_public_path__ + "static/img/ykb_logo.57ef3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ykb_logo.png
// module id = s8qj
// module chunks = 1